module.exports = {
	"classes": [
		"ambassador-program"
	],
	"title": "Ambassador Program",
	"metas": {
		"description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?"
	},
	"opengraph": {
		"og:title": "Ambassador Program",
		"og:description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?",
		"og:url": "https://auth0.com/ambassador-program",
		"og:image": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-03c5b828c9.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-03c5b828c9.png"
	},
	"twittercard": {
		"twitter:title": "Ambassador Program",
		"twitter:description": "Do you want to serve the developer community, make the internet safer, and build your brand while you’re at it?",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/ambassador-program/assets/ambassador-twitter-card-03c5b828c9.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ambassador-program/metadata.json
// module id = 1104
// module chunks = 0